class ConfirmationModal
{
  constructor()
  {
    this.container = document.querySelector('.modal-confirmation');
    this.title = document.querySelector('.modal-confirmation__title');
    this.body = document.querySelector('.modal-confirmation__body');
    this.confirm_button = document.querySelector('.modal-confirmation__button-confirm');
    this.cancel_button = document.querySelector('.modal-confirmation__button-cancel');

    this.confirm_button.addEventListener('click', this.handle_confirm.bind(this));
    this.cancel_button.addEventListener('click', this.handle_cancel.bind(this));

    this.on_confirm = () => console.warn('No on_confirm callback provided');
    this.on_cancel = () => console.warn('No on_cancel callback provided');
  }

  show({ title, body, confirm_button_text, cancel_button_text, on_confirm, on_cancel })
  {
    this.container.classList.remove('hidden');
    this.title.innerHTML = title;
    this.body.innerHTML = body;
    this.confirm_button.innerHTML = confirm_button_text;
    this.cancel_button.innerHTML = cancel_button_text;
    this.on_confirm = on_confirm;
    this.on_cancel = on_cancel;
  }

  hide()
  {
    this.container.classList.add('hidden');
  }

  handle_confirm()
  {
    this.on_confirm();
    this.reset();
  }

  handle_cancel()
  {
    this.on_cancel();
    this.reset();
  }

  reset()
  {
    this.on_confirm = () => console.warn('No on_confirm callback provided');
    this.on_cancel = () => console.warn('No on_cancel callback provided');
    this.title.innerHTML = '';
    this.body.innerHTML = '';
    this.confirm_button.innerHTML = '';
    this.cancel_button.innerHTML = '';
    this.container.classList.add('hidden');
  }
}

const confirmation_modal = new ConfirmationModal();
export { confirmation_modal as ConfirmationModal };
